(function(){
  const handle = window.articleHandle;
  const webAppUrl = "https://script.google.com/macros/s/AKfycbzDHTHpTv-kTixlDr7NxHOszz3p3YFAuNlUm8nuIP5QmvvLLOe0rXp0KntNlgD63ZgNlQ/exec";

  fetch(`${webAppUrl}?action=increment&handle=${handle}`)
    .then(response => response.json())
    .then(data => {
      if(data.status === 'success'){
        document.getElementById('blog-views').innerText = `👁️views：${data.views}`;
      } else {
        document.getElementById('blog-views').innerText = '⚠️ Failed to load view count';
      }
    })
    .catch(() => {
      document.getElementById('blog-views').innerText = '⚠️ Failed to load view count';
    });
})();
